<template>
  <el-row class="el-main" style="height:100vh;"  :element-loading-background="
        loading.background || this.$loadingDefault.background
      "
      :element-loading-text="loading.text || this.$loadingDefault.text"
      v-loading="loading.display">
    <el-col :span="6" class="el-aside">
      <el-menu :model="module">
        <el-submenu v-for="mod in module" :index="mod.id" :key="mod.id">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>{{ mod.name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="item in mod.items"
              :index="item.id"
              :key="item.id"
              @click="handleOpenApi(item)"
            >
              {{ item.name }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-col>
    <el-col :span="10" style="padding:0px 10px 0px;">
      <el-collapse v-model="activeNamesParam" @change="handleChange">
        <el-collapse-item title="Path" name="1">
          <el-form ref="form" :model="moduleItem" label-width="80px">
            <el-form-item label="Path">
              <el-input v-model="moduleItem.path"></el-input>
            </el-form-item>
            <el-form-item label="Method">
              <el-select
                v-model="params.method"
                value-key="value"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in methods"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                type="success"
                @click="handleRunApi"
                style="margin-left:10px;"
                >运行</el-button
              >
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item title="Hearder" name="2">
          <el-table :data="params.header" style="width: 100%">
            <el-table-column prop="key" label="Key">
              <template slot-scope="scope">
                <el-input v-model="scope.row.key"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="Value">
              <template slot-scope="scope">
                <el-input v-model="scope.row.value"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="Remark">
              <template slot-scope="scope">
                {{ scope.row.remark }}
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Query" name="3">
          <el-table :data="params.query" style="width: 100%">
            <el-table-column prop="key" label="Key">
              <template slot-scope="scope">
                <el-input v-model="scope.row.key"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="Value">
              <template slot-scope="scope">
                <el-input v-model="scope.row.value"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="Remark">
              <template slot-scope="scope">
                {{ scope.row.remark }}
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Body" name="4">
          <!-- <bo-json-editor :json="params.body" @keyup.up="handleJsonChange" @change="handleJsonChange" :props="{rows:5}" > </bo-json-editor> -->
          <bo-json-view :json="params.body"></bo-json-view>
        </el-collapse-item>
      </el-collapse>
    </el-col>
    <el-col :span="8">
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item title="Result【error】" name="1">
          <bo-json-view :json="result.error"></bo-json-view>
        </el-collapse-item>
        <el-collapse-item title="Result【success】" name="2">
          <bo-json-view :json="result.success"></bo-json-view>
        </el-collapse-item>
      </el-collapse>
    </el-col>
  </el-row>
</template>
<style scoped>
.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>
<script>
require("../../styles/api/index-api.scss");
import { queryModule, queryRequest } from "../../actions/apis/doc";
import axios from "../../utils/axios";
import { BASE_API } from "../../config/app";

export default {
  data() {
    return {
      loading: {
        display: false,
        background: null,
        text: null
      },
      activeNames: ["1", "2"],
      activeNamesParam: ["1", "2", "3", "4"],
      moduleItem: {},
      methods: [
        {
          name: "GET(查询)",
          value: "get"
        },
        {
          name: "POST（新增）",
          value: "post"
        },
        {
          name: "PUT（修改）",
          value: "put"
        },
        {
          name: "DELETE（删除）",
          value: "delete"
        },
        {
          name: "PATCH（局部更新）",
          value: "patch"
        }
      ],
      contentTypes: [],
      module: [],
      result: {
        success: {},
        error: {}
      },
      params: {
        name: "用户列表",
        path: "",
        ref: {
          mkey: "user",
          resField: "brower",
          file: "login"
        },
        state: 1,
        remark: 1,
        method: "get",
        query: [],
        header: [],
        body: {}
      }
    };
  },
  components: {
    BoJsonEditor: () => import("../../components/bo-json-editor"),
    BoJsonView: () => import("../../components/bo-json-view")
  },
  mounted() {
    let that = this;
    that.loadModule();
  },
  methods: {
    loadModule() {
      let that = this;
      let params = {
        ownerId: window.$config.ownerId
      };
      that.loading.display = true;
      queryModule(params).then(res => {
        that.loading.display = false;
        if (!res) return;
        that.module = res.data.module;
      });
    },
    handleJsonChange(data) {
      this.params.body = data;
    },
    handleOpenApi(item) {
      let that = this;
      that.params.ref = item.ref;

      let params = that.params.ref || {};
      params.ownerId = window.$config.ownerId;
      that.moduleItem = item;
      queryRequest(params, that.moduleItem).then(res => {
        // that.loading.display=false;
        if (!res) return;
        that.params.query = res.data.query || [];
        that.params.header = res.data.header || [];
        that.params.body = res.data.body || {};
        that.result.error = res.data.error || {};
        that.result.success = res.data.success || {};
        that.params.method=res.data.method;

        // for (let index in res.data) {
        //     res.data[index]["popedom" + res.data[index].popedom] = res.data[index].popedom;
        // }
        // that.field.columns[row.id] = res.data;
        // that.field.data = res.data;
        // that.dialog.visible = true;
      });
    },
    handleChange() {},
    handleRunApi() {
      let that = this;
      let query = {};
      for (let a of that.params.query) {
        query[a.key] = a.value;
      }
      that.loading.display = true;
      axios({
        url: window.$config.url.baseApi + that.moduleItem.path,
        method: that.params.method,
        params: query,
        data: that.params.body
      }).then(res => {
        that.loading.display = false;
        if(!res)return;
        if (res.success === true) {
          that.result.success = res;
        } else {
          that.result.error = res;
        }
      });
    }
  }
};
</script>
